import { render, staticRenderFns } from "./ReasonCodeColumn.vue?vue&type=template&id=505008cc&scoped=true&"
import script from "./ReasonCodeColumn.vue?vue&type=script&lang=js&"
export * from "./ReasonCodeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505008cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
